import React from 'react';
import styles from './StudentInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import Dropdown from '../../../../components/Dropdown';

const SEX_OPTIONS = [
    { value: 'M', title: 'Masculin' },
    { value: 'F', title: 'Feminin' },
];

const NATIONALITY_OPTIONS = [
    {value : '1', title: 'Française'}, 
    {value : '2', title: 'Union Européenne'},
    {value : '3', title: 'Etranger hors Union Européenne'},
]

const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

const StudentInformations = ({ prospect, onProspectChange, onDropdownChange }) => {
    return (
        <Card className={styles.card} title="Informations du prospect" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom"
                    name="last_name"
                    type="text"
                    placeholder="Nom de l'élève"
                    value={prospect?.last_name || ''}
                    onChange={onProspectChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Nom d'usage"
                    name="usage_name"
                    type="text"
                    placeholder="Nom d'usage"
                    value={prospect?.usage_name || ''}
                    onChange={onProspectChange}
                />
                <TextInput
                    className={styles.field}
                    label="Prénom"
                    name="first_name"
                    type="text"
                    placeholder="Prénom de l'élève"
                    value={prospect?.first_name || ''}
                    onChange={onProspectChange}
                    required
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Sexe"
                        name="sex"
                        required
                        options={SEX_OPTIONS}
                        setValue={(option) => onDropdownChange('sex', option.value)}
                        value={SEX_OPTIONS.find(opt => opt.value === prospect?.sex) || ''}
                    />
                </div>
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Nationalité"
                        name="nationality"
                        options={NATIONALITY_OPTIONS}
                        setValue={(option) => onDropdownChange('nationality', option.value)}
                        value={NATIONALITY_OPTIONS.find(opt => opt.value === prospect?.nationality) || ''}
                    />
                </div>
                <TextInput
                    className={styles.field}
                    label="Date de naissance"
                    name="birth_date"
                    type="date"
                    value={formatDateForInput(prospect?.birth_date)}
                    onChange={onProspectChange}
                />
            </div>
        </Card>
    );
};

export default StudentInformations;